import React from 'react';

import * as styles from './ProductCount.styles';

export interface ProductCountProps {
  count: number;
}

export const ProductCount = ({ count }: ProductCountProps) => (
  <p css={styles.productCount}>
    {count.toLocaleString('en-GB')} {count === 1 ? 'product' : 'products'}
  </p>
);
